import { render, staticRenderFns } from "./ShipSideView.vue?vue&type=template&id=8c44bdda"
import script from "./ShipSideView.vue?vue&type=script&lang=ts"
export * from "./ShipSideView.vue?vue&type=script&lang=ts"
import style0 from "./ShipSideView.vue?vue&type=style&index=0&id=8c44bdda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports